import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from '../../organization/hooks/useSelectedOrganization';

export const useUpdateConversionRate = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  const { selectedOrganization } = useSelectedOrganization();

  return useMutation({
    mutationFn: (creditConversionRate: number) =>
      client.fetchApi<void, { creditConversionRate: number }>({
        endpoint: `organizations/${selectedOrganization?.id}/credit-conversion-rate`,
        method: 'POST',
        body: { creditConversionRate },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['my-organizations'] });
    },
  });
};
